import { useEffect } from 'react';
import { openModal } from '@kcd/app-interface/dist/web2app';
import { Button } from '@kcd/design-system';
import { trackEvent } from '@kcd/event-tracker';

import { useMembershipStatus } from '../../hooks/useMembershipStatus';

import {
  BonuspackCloverFill18x18Icon,
  ChevronRightIcon,
  MembershipStandard28x14Icon,
} from '~/assets/icons';

export function ProductDetailMembersipNudge() {
  const {
    isMembershipSubscribeServiceAvailable,
    isTrialAvailable,
    isAvailableToSubscribe,
    isAvailableToSubscribeBonusPack,
    getRegisterMembershipUrl,
  } = useMembershipStatus();

  const nudgeType = (() => {
    if (isTrialAvailable) {
      return 'plus_membership_free';
    }

    if (isAvailableToSubscribe) {
      return 'plus_membership';
    }

    if (isAvailableToSubscribeBonusPack) {
      return 'lucky_bonus_pack';
    }

    return '';
  })();

  useEffect(() => {
    trackEvent('viewed banner in 마켓/상품상세/멤버십넛지', {
      clicked_area: 'nudge_below_price',
      membership_nudge_type: nudgeType,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickRegisterMembership = () => {
    const registerUrl = getRegisterMembershipUrl();

    trackEvent('clicked button in 마켓/상품상세/멤버십넛지', {
      clicked_area: 'nudge_below_price',
      membership_nudge_type: nudgeType,
    });

    if (registerUrl) {
      openModal({
        url: registerUrl,
      });
    }
  };

  const nudgeContent = (() => {
    if (isTrialAvailable) {
      return (
        <>
          <p className="flex min-h-32 items-center gap-4 typo-paragraph200-semibold">
            <MembershipStandard28x14Icon />총 6만원 쿠폰팩
          </p>
          <span className="flex items-center gap-4 text-accent typo-paragraph100-semibold">
            첫 4주 무료체험
            <ChevronRightIcon className="[&_path]:fill-blue-600" />
          </span>
        </>
      );
    }

    if (isAvailableToSubscribe) {
      return (
        <>
          <p className="flex min-h-32 items-center typo-paragraph100-regular">
            <MembershipStandard28x14Icon className="mr-4" />
            <span className="text-accent typo-paragraph100-semibold">
              멤버십
            </span>
            &nbsp;가입 시&nbsp;
            <strong className="text-accent typo-paragraph100-semibold">
              월 6만원 추가 할인
            </strong>
          </p>
          <Button type="button" size="xs" variant="primary">
            받기
          </Button>
        </>
      );
    }

    if (isAvailableToSubscribeBonusPack) {
      return (
        <>
          <span className="flex min-h-32 items-center gap-4 typo-paragraph200-semibold">
            <BonuspackCloverFill18x18Icon />총 2만원 쿠폰팩에 보너스할인까지
          </span>
          <Button type="button" size="xs" variant="primary">
            받기
          </Button>
        </>
      );
    }

    return null;
  })();

  if (!isMembershipSubscribeServiceAvailable || !nudgeContent) return null;

  return (
    <button
      type="button"
      className="flex w-full items-center justify-between rounded-16 bg-blue-100 px-16 py-12"
      onClick={onClickRegisterMembership}
    >
      {nudgeContent}
    </button>
  );
}
